export const CONFIRM = 'confirm';
export const CANCEL = 'cancel';
export const UNASSIGN = 'unassign';
